import React from "react";
import { ProjectRowProps } from "./types";
import { extractCarbonProjectProperties } from "./utils";

/**
 * Renders a single table row for a project
 */
export const ProjectTableRow: React.FC<ProjectRowProps> = ({
  item,
  columns,
  onRowClick,
  index,
  isLast,
}) => {
  const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";
  const centerClasses = isLast
    ? "p-4 text-center"
    : "text-center p-4 items-center border-b border-blue-gray-50";

  // Extract properties for carbon projects (which have nested structure)
  const projectData = extractCarbonProjectProperties(item);

  const handleRowClick = () => {
    if (onRowClick) {
      onRowClick(item);
    }
  };

  const getCellValue = (columnKey: string) => {
    // Handle nested properties for carbon projects
    return projectData[columnKey] ?? item[columnKey];
  };

  const shouldUseCenterClasses = (columnKey: string) => {
    // Use center classes for forestation projects (they use different styling)
    return item.adm1 !== undefined && item.adm2 !== undefined;
  };

  return (
    <tr key={index} onClick={handleRowClick} className="cursor-pointer hover:bg-gray-50">
      {columns.map((column) => {
        const cellClasses = shouldUseCenterClasses(column.key) ? centerClasses : classes;

        const cellValue = getCellValue(column.key);
        const renderedContent = column.render ? column.render(cellValue, item) : cellValue;

        return (
          <td
            key={column.key}
            className={cellClasses}
            style={{
              width: column.width,
              minWidth: column.minWidth,
            }}
          >
            {renderedContent}
          </td>
        );
      })}
    </tr>
  );
};
